import type { ReactNode } from "react";

export function ReportSection({ eyebrow, title, children }: { eyebrow: string; title: string; children: ReactNode }) {
  return (
    <section className="report-section py-10 md:py-14">
      <p className="eyebrow">{eyebrow}</p>
      <h2 className="section-title mb-7">{title}</h2>
      {children}
    </section>
  );
}
